(function () {
'use strict';
var m=window.location.pathname.match(/^\/pages\/genetics-identity\/([^/?#]+)\/?$/i);
if(!m)return;
var handle=decodeURIComponent(m[1]).toLowerCase();
var store=window.LLGA_STRICT_DESCENDANTS||{};
var record=store[handle];
if(!record||!Array.isArray(record.links)||!record.links.length)return;
if(document.getElementById('llga-strict-descendants'))return;
var root=document.querySelector('.llga-record');
if(!root)return;
var lineageCard=document.getElementById('llga-lineage-card');
var lineageSection=lineageCard?lineageCard.closest('.llga-section'):null;

var section=document.createElement('div');
section.id='llga-strict-descendants';
section.className='llga-section llga-descendants-section';

var h2=document.createElement('h2');
h2.textContent='Documented Descendants';
section.appendChild(h2);

var card=document.createElement('div');
card.className='llga-card llga-card-wide llga-descendants-card';

var label=document.createElement('div');
label.className='llga-label';
label.textContent='Strict resolved lineage relationships';
card.appendChild(label);

var intro=document.createElement('p');
intro.className='llga-descendants-intro';
var total=Number(record.count||record.links.length);
intro.textContent=total>record.links.length
?'Showing '+record.links.length+' of '+total+' direct descendant identities documented in the LLGA strict lineage layer.'
:total+' direct descendant '+(total===1?'identity':'identities')+' documented in the LLGA strict lineage layer.';
card.appendChild(intro);

var grid=document.createElement('div');
grid.className='llga-descendants-grid';
record.links.forEach(function(child){
if(!child||!child.h||!child.n||child.h.toLowerCase()===handle)return;
var a=document.createElement('a');
a.className='llga-descendant-link';
a.href='/pages/genetics-identity/'+encodeURIComponent(child.h);
var n=document.createElement('span');n.textContent=child.n;
var arrow=document.createElement('span');arrow.className='llga-descendant-arrow';arrow.setAttribute('aria-hidden','true');arrow.textContent='→';
a.appendChild(n);a.appendChild(arrow);grid.appendChild(a);
});
if(!grid.children.length)return;
card.appendChild(grid);section.appendChild(card);

var style=document.createElement('style');
style.textContent='.llga-descendants-card{min-height:0}.llga-descendants-intro{margin:0 0 18px;max-width:850px;font-size:14px;line-height:1.65;opacity:.72}.llga-descendants-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px}.llga-descendant-link{display:flex;align-items:center;justify-content:space-between;gap:14px;padding:13px 15px;border:1px solid rgba(0,0,0,.12);border-radius:10px;color:inherit;text-decoration:none;font-size:14px;line-height:1.35;background:rgba(0,0,0,.012);transition:border-color .16s ease,background .16s ease,transform .16s ease}.llga-descendant-link:hover{border-color:rgba(0,0,0,.42);background:rgba(0,0,0,.03);transform:translateY(-1px)}.llga-descendant-link:focus-visible{outline:2px solid currentColor;outline-offset:2px}.llga-descendant-arrow{flex:0 0 auto;opacity:.5;font-size:16px}@media(max-width:749px){.llga-descendants-grid{grid-template-columns:1fr}.llga-descendant-link{padding:12px 13px}}';
section.appendChild(style);

if(lineageSection&&lineageSection.parentNode===root)lineageSection.insertAdjacentElement('afterend',section);
else root.appendChild(section);
})();